// Navbar.jsx
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./Navbar.module.css";

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className={styles.nav}>
      <div className={styles.navInner}>
        <Link to="/" className={styles.logo}>
          myapple.gr
        </Link>

        <div className={styles.links}>
          <Link to="/" className={`${styles.link} ${isActive("/") ? styles.active : ""}`}>Home</Link>
          <Link to="/about" className={`${styles.link} ${isActive("/about") ? styles.active : ""}`}>About</Link>
          <Link to="/services" className={`${styles.link} ${isActive("/services") ? styles.active : ""}`}>Services</Link>
          <Link to="/portfolio" className={`${styles.link} ${isActive("/portfolio") ? styles.active : ""}`}>Portfolio</Link>
          <Link to="/savings-calculator" className={`${styles.link} ${isActive("/savings-calculator") ? styles.active : ""}`}>Calculator</Link>
          <Link to="/contact" className={`${styles.link} ${isActive("/contact") ? styles.active : ""}`}>Contact</Link>
        </div>

        <div className={styles.actions} style={{ marginLeft: "auto" }}>
          <div className={styles.burger} onClick={() => setMenuOpen(!menuOpen)}>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
            <div className={styles.bar}></div>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className={styles.mobileMenu}
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "spring", stiffness: 300, damping: 30 }}
          >
            <Link to="/" onClick={() => setMenuOpen(false)} className={styles.mobileLink}>Home</Link>
            <Link to="/about" onClick={() => setMenuOpen(false)} className={styles.mobileLink}>About</Link>
            <Link to="/services" onClick={() => setMenuOpen(false)} className={styles.mobileLink}>Services</Link>
            <Link to="/portfolio" onClick={() => setMenuOpen(false)} className={styles.mobileLink}>Portfolio</Link>
            <Link to="/savings-calculator" onClick={() => setMenuOpen(false)} className={styles.mobileLink}>Calculator</Link>
            <Link to="/contact" onClick={() => setMenuOpen(false)} className={styles.mobileLink}>Contact</Link>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
